'use strict';

var jsxRuntime = require('react/jsx-runtime');
var react = require('react');
var utilities_combineClasses = require('../_chunks/combineClasses-5P8GTQkg.js');
var theme_index = require('../_chunks/index-CIVOGJRG.js');
require('../_chunks/designTokens-CKP-YoT2.js');

require("../_assets/Icon-B21GTj9b.css");var styles = {"clickable":"Icon__ETSzORbO2g__clickable","icon":"Icon__ETSzORbO2g__icon"};

const ICON_SIZE_TO_PX = {
    'extra-small': '12px',
    small: '16px',
    normal: '24px',
    large: '32px',
};
const gridSize = 24;
const IconContainer = react.forwardRef(({ children, size: _size = 'normal', rotation = 0, theme: _theme = 'default', themeVariant = 'normal', color, className = '', onClick, style, testId, ...props }, ref) => {
    const size = ICON_SIZE_TO_PX[_size] ?? _size;
    return (jsxRuntime.jsx("svg", { width: size, height: size, viewBox: `0 0 ${gridSize} ${gridSize}`, className: utilities_combineClasses.combineClasses(styles.icon, onClick && styles.clickable, className), style: {
            '--icon--fill-and-stroke': theme_index.theme.color[color] ?? color,
            ...style,
        }, onClick: onClick, "data-testid": testId, "data-theme": color ? undefined : _theme, "data-variant": color ? undefined : themeVariant, "aria-hidden": props['aria-label'] || props['aria-labelledby'] ? undefined : true, ...props, ref: ref, children: jsxRuntime.jsx("g", { transform: `rotate(${rotation} ${gridSize / 2} ${gridSize / 2})`, children: children }) }));
});
IconContainer.displayName = 'IconContainer';
const getSvgProps = ({ className, onClick, style, testId, }) => {
    return {
        className,
        onClick,
        style,
        'data-test-id': testId,
    };
};
const iconFactory = (displayName, children, defaultProps) => {
    const IconComponent = react.forwardRef((props, ref) => {
        return (jsxRuntime.jsx(IconContainer, { testId: displayName, ...defaultProps, ...props, className: utilities_combineClasses.combineClasses(defaultProps?.className, props.className), ref: ref, children: typeof children === 'function' ? children() : children }));
    });
    IconComponent.displayName = displayName;
    return IconComponent;
};

exports.ICON_SIZE_TO_PX = ICON_SIZE_TO_PX;
exports.IconContainer = IconContainer;
exports.getSvgProps = getSvgProps;
exports.iconFactory = iconFactory;
//# sourceMappingURL=Icon.js.map
